/* eslint-disable import/no-anonymous-default-export */
import verificationTypes from './verification.types';

const INITIAL_STATE = {
	aadharOtpVerifyResponse: null,
	sendAadharOtpResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** SEND AADHAR OTP START *********************** */
		case verificationTypes.SEND_AADHAR_OTP_SUCCESS:
			return {
				...state,
				sendAadharOtpResponse: action.payload,
			};

		case verificationTypes.SEND_AADHAR_OTP_FAILURE:
			return { ...state, sendAadharOtpResponse: action.payload };

		case verificationTypes.SEND_AADHAR_OTP_RESPONSE_CHANGED:
			return { ...state, sendAadharOtpResponse: null };
		/** ***************** SEND AADHAR OTP END *********************** */

		/** ***************** AADHAR OTP VERIFY START *********************** */
		case verificationTypes.AADHAR_OTP_VERIFY_SUCCESS:
			return {
				...state,
				aadharOtpVerifyResponse: action.payload,
			};
		case verificationTypes.AADHAR_OTP_VERIFY_FAILURE:
			return { ...state, aadharOtpVerifyResponse: action.payload };

		case verificationTypes.AADHAR_OTP_VERIFY_RESPONSE_CHANGED:
			return { ...state, aadharOtpVerifyResponse: null };
		/** ***************** AADHAR OTP VERIFY END *********************** */

		default:
			return state;
	}
};
